import { IconUser } from '@tabler/icons-react'

import { type Expense, ExpenseType } from '@subaio/api-types/budget'
import { FormattedMessage } from '@subaio/components'
import { cases } from '@subaio/utils'

import { Frequency } from 'components/Frequency'
import { Cell, HeaderRow } from 'components/Lists'
import { ProductLogo } from 'components/ProductLogo'

import { Amount } from '../../Amount'
import { Item } from './Item'

export type Props = Expense & {
	amountToShow: 'default' | 'threeMonthsAverage' | 'twelveMonthsAverage'

	onClick?: (service: Expense) => void
}

export const UncategorizedService = (service: Props) => {
	const {
		title,
		currency = 'DKK',
		amountToShow = 'default',
		paymentCost,
		averageLastThreeMonths,
		averageLastTwelveMonths,
		paymentFrequency,
		imageUrl,
		type,
		onClick,
	} = service

	return (
		<Item>
			<HeaderRow isDisabled={!onClick} onClick={onClick ? () => onClick(service) : undefined}>
				<Cell textAlign='center'>
					{type === ExpenseType.UserProvided ? (
						<IconUser size={40} strokeWidth={1.2} />
					) : (
						<ProductLogo size={40} imageUrl={imageUrl} title={title} />
					)}
				</Cell>
				<Cell shouldExpand>{title}</Cell>
				<Cell textAlign='right'>
					<Amount
						amount={
							type === ExpenseType.UserProvided
								? paymentCost
								: cases(amountToShow, {
										default: paymentCost,
										threeMonthsAverage: averageLastThreeMonths,
										twelveMonthsAverage: averageLastTwelveMonths,
									})
						}
						currency={currency}
						userProvidedAmount={null}
						caption={cases(amountToShow, {
							default: paymentFrequency && (
								<div>
									<Frequency frequency={paymentFrequency} />
								</div>
							),
							threeMonthsAverage: (
								<div>
									<FormattedMessage
										id='flow.budgetEditForm.serviceThreeMonthsAverage'
										defaultMessage='3 months average'
									/>
								</div>
							),
							twelveMonthsAverage: (
								<div>
									<FormattedMessage
										id='flow.budgetEditForm.serviceTwelveMonthsAverage'
										defaultMessage='12 months average'
									/>
								</div>
							),
						})}
					/>
				</Cell>
			</HeaderRow>
		</Item>
	)
}
